export interface PaymentCardInterface {
  amount: number,
  deliverables: string[],
  deliveryDurationEpoch: number,
  revisionCharge: number,
  noOfRevisions: number,
  remarks: string
}

export interface MetaDataInterface {
  buyerId: string,
  sellerId: string,
  gigId: string,
  channelId: string,
  createdAt: string,
  updatedAt: string
}

export interface ActionCardInterface {
  id: string,
  type: string,
  status: string,
  orderDetails: PaymentCardInterface,
  validTill: Date,
  metaData: MetaDataInterface
}

export class ActionCard implements ActionCardInterface {
  id: string;
  type: string;
  status: string;
  orderDetails: PaymentCardInterface;
  metaData: MetaDataInterface;
  validTill: Date;

  constructor(jsonData: any) {
    this.id = jsonData._id
    this.type = jsonData.type
    this.status=  jsonData.status
    this.orderDetails = jsonData.orderDetails
    this.metaData = jsonData.metaData
    this.validTill = jsonData.validTill
  }
}